import { createContext, useContext, useEffect, useState } from 'react'

import { api } from '../../api/clients'
import { TaskSortType } from '../../client'
import { RepositoryStore } from '../../interfaces/repository.types'
import { usePaginationStore } from '../../utils/stores/pagination.store'
import { Task, TaskFilters } from './task.interface'
import { transformTask, transformToSearchRequest } from './task.transformer'

export function useTasksPaginationStore(
  repository: RepositoryStore<Task>,
  initialFilters: TaskFilters = {},
) {
  const [filters, setFilters] = useState<TaskFilters>(initialFilters)

  const pagination = usePaginationStore<Task>({
    repository,
    fetchItems: async (page: number, pageSize: number) => {
      const response = await api.tasks.searchTasks(
        transformToSearchRequest(page, pageSize, filters, TaskSortType.CreatedAt),
      )

      return {
        ...response.data,
        ...filters,
        items: response.data.items.map(transformTask),
      }
    },
  })

  const clear = () => {
    setFilters({})
    pagination.clear()
  }

  useEffect(() => {
    if (pagination.active) {
      pagination.fetchPage(0)
    }
  }, [filters])

  return {
    ...pagination,

    filters,
    setFilters: (newValue: Partial<TaskFilters>) =>
      setFilters((current) => ({ ...current, ...newValue })),
    clear,
  }
}

export type TasksPaginationStore = ReturnType<typeof useTasksPaginationStore>

export const TasksPaginationStoreContext = createContext<TasksPaginationStore>({
  isLoading: true,
} as any)

export function getTasksPaginationStore() {
  return useContext(TasksPaginationStoreContext)
}
